module.exports = __webpack_public_path__ + "static/media/pii1.9f780526.jpg";